import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CONTRACT_STATUSES } from '../../../../../shared/services/ContractStatuses';
import { Report, RowActions } from '../../../report/report';
import { FetchContractRequestsService } from './fetch-contract-requests.service';

@Component({
  selector: 'app-contracts',
  templateUrl: './contracts.component.html',
  styleUrls: ['./contracts.component.scss']
})
export class ContractsComponent implements OnInit {

  totalNumberOfRecords = 0;
  contractRequests: any[] = [];
  requestBody: Report = {};
  loading = false;

  tableColumns = [
    'name',
    'contractStatus',
    'TotalSales',
    'date',
    'businessType',
  ]

  displayTableColumns = {
    'name': 'Bussines Name',
    'contractStatus': 'Status',
    'TotalSales': "Total Sales",
    'date': 'Date',
    'businessType': 'Business Registered'
  };

  colTypes = {
    'businessType': 'businessType'
  };

  rowActions: RowActions[] = [{
    actionName: 'View',
    actionType: 'Button',
    actionClass: 'btn-primary',
  }];

  filterField = [
    {
      filterFieldName: "contractStatus",
      filterDisplayName: "Contract Status",
      defaultValue: "",
      filterOptions: [
        { key: "Show All", value: null },
        { key: CONTRACT_STATUSES.key.SUBMITTED, value: CONTRACT_STATUSES.value.SUBMITTED },
        { key: CONTRACT_STATUSES.key.CONFIRMED, value: CONTRACT_STATUSES.value.CONFIRMED },
        { key:  CONTRACT_STATUSES.key.SHIPPED, value : CONTRACT_STATUSES.value.SHIPPED },
        { key: CONTRACT_STATUSES.key.SIGNED, value: CONTRACT_STATUSES.value.SIGNED },
      ]
    }
  ];

  constructor(
    public fetchContractRequestsService: FetchContractRequestsService,
    private router: Router
  ) { }


  ngOnInit() {
    this.fetchContractRequestsService.activateLoader();
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };

    this.updateTable();
  }

  actionsCB(event: any) {
    this.router.navigate([`/seller/settings/contract/${event.key.id}`]);
  }

  async paginate(event: any) {
    this.requestBody.paginationOptions = {
      start: event.pageIndex * event.pageSize,
      limit: event.pageSize
    };
    this.updateTable();
    this.fetchContractRequestsService.loader().subscribe(val => (this.loading = val));
  }

  async filter(event: any) {
    if (event && Object.keys(event).length) {
      this.requestBody.filterOptions = event;
    } else {
      this.requestBody.filterOptions = {};
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
    this.fetchContractRequestsService.loader().subscribe(val => (this.loading = val));
  }

  async sortChange(event: any) {
    if (event.direction === '') {
      this.requestBody.sortOptions = {};
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction
      };
    }
    await this.updateTable();
    this.fetchContractRequestsService.loader().subscribe(val => (this.loading = val));
  }

  async updateTable() {
    this.fetchContractRequestsService.activateLoader();
    this.fetchContractRequestsService.setParams(this.requestBody);
    const report = await this.fetchContractRequestsService.make();
    this.contractRequests = report.result;
    this.totalNumberOfRecords = report.totalNumberOfRows;
  }

  async searchChange(event: any) {
    console.log(event)
    if (event) {
      this.requestBody.searchOptions = {
        searchKey: event
      };
    } else {
      this.requestBody.searchOptions = undefined;
      this.fetchContractRequestsService.loader().subscribe(val => (this.loading = val));
    }
    await this.updateTable();
  }
}
